/**
 * What repeating a tool call would do. `none` is never journaled;
 * `idempotent` may be repeated after an interrupted run because its downstream
 * enforces an idempotency key; `interruptible` is reported to the model as
 * interrupted and the run continues, because the agent can check its effect
 * itself; `irreversible` stops the run until a person has checked.
 */
export const TOOL_SIDE_EFFECTS = ["none", "idempotent", "interruptible", "irreversible"] as const;
export type ToolSideEffect = (typeof TOOL_SIDE_EFFECTS)[number];
